import { render, staticRenderFns } from "./BulkActionWizard.vue?vue&type=template&id=b05a247e&scoped=true&"
import script from "./BulkActionWizard.vue?vue&type=script&lang=js&"
export * from "./BulkActionWizard.vue?vue&type=script&lang=js&"
import style0 from "./BulkActionWizard.vue?vue&type=style&index=0&id=b05a247e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b05a247e",
  null
  
)

export default component.exports